export const CATEGORIAS_EGRESO = {
  general: 'General',
  liturgico: 'Litúrgico',
  misional: 'Misional'
} as const;

export type CategoriaEgreso = keyof typeof CATEGORIAS_EGRESO;

export const SUBCATEGORIAS_GENERALES = [
  'Arriendo',
  'Luz',
  'Agua',
  'Gas',
  'Internet',
  'Teléfono',
  'Mantención',
  'Limpieza',
  'Reparación',
  'Otra'
] as const;

export const SUBCATEGORIAS_LITURGICAS = [
  'Pan',
  'Mosto',
  'Velas',
  'Flores',
  'Espuma Floral',
  'Incienso',
  'Ornamentos',
  'Manteles y Paños',
  'Implementos',
  'Otra'
] as const;

export const SUBCATEGORIAS_MISIONALES = [
  'Campaña Tecnoctrónica',
  'Arriendo Salón',
  'Afiches',
  'Volantes',
  'Tarjetas de presentación',
  'Pendón',
  'Stand',
  'Otra'
] as const;

export type SubcategoriaGeneral = typeof SUBCATEGORIAS_GENERALES[number];
export type SubcategoriaLiturgica = typeof SUBCATEGORIAS_LITURGICAS[number];
export type SubcategoriaMisional = typeof SUBCATEGORIAS_MISIONALES[number];

export const getSubcategoriasPorCategoria = (categoria: CategoriaEgreso): readonly string[] => {
  if (categoria === 'general') return SUBCATEGORIAS_GENERALES;
  if (categoria === 'misional') return SUBCATEGORIAS_MISIONALES;
  return SUBCATEGORIAS_LITURGICAS;
};

export function getReembolsoPillClass(esDonacion: boolean, requiereReembolso: boolean): string {
  if (esDonacion) return 'border-slate-200 bg-slate-100 opacity-50 cursor-not-allowed';
  if (requiereReembolso) return 'border-amber-400 bg-amber-50 cursor-pointer';
  return 'border-slate-200 bg-slate-50 hover:border-slate-300 cursor-pointer';
}

export function computeGastoPillClasses(esDonacion: boolean, requiereReembolso: boolean) {
  const reembolsoActive = !esDonacion && requiereReembolso;
  return {
    donacionPill: esDonacion ? 'border-emerald-400 bg-emerald-50' : 'border-slate-200 bg-slate-50 hover:border-slate-300',
    donacionCheck: esDonacion ? 'border-emerald-500 bg-emerald-500' : 'border-slate-300 bg-white',
    donacionGift: esDonacion ? 'text-emerald-600' : 'text-slate-400',
    donacionText: esDonacion ? 'text-emerald-800' : 'text-slate-700',
    reembolsoCheck: reembolsoActive ? 'border-amber-500 bg-amber-500' : 'border-slate-300 bg-white',
    reembolsoText: reembolsoActive ? 'text-amber-800' : 'text-slate-700',
  };
}
